module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2023_de-7d8bd21ce6a17b238528d125ccee0a62.jpg";